/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether a playable ad runs across all surfaces or only the ones named in hosts.
 * @export
 */
export const SurfaceDisplayScope = {
    ALL_SURFACES: 'ALL_SURFACES',
    SPECIFIC_SURFACES: 'SPECIFIC_SURFACES'
} as const;
export type SurfaceDisplayScope = typeof SurfaceDisplayScope[keyof typeof SurfaceDisplayScope];


export function instanceOfSurfaceDisplayScope(value: any): boolean {
    for (const key in SurfaceDisplayScope) {
        if (Object.prototype.hasOwnProperty.call(SurfaceDisplayScope, key)) {
            if (SurfaceDisplayScope[key as keyof typeof SurfaceDisplayScope] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceDisplayScopeFromJSON(json: any): SurfaceDisplayScope {
    return SurfaceDisplayScopeFromJSONTyped(json, false);
}

export function SurfaceDisplayScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceDisplayScope {
    return json as SurfaceDisplayScope;
}

export function SurfaceDisplayScopeToJSON(value?: SurfaceDisplayScope | null): any {
    return value as any;
}

export function SurfaceDisplayScopeToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceDisplayScope {
    return value as SurfaceDisplayScope;
}

